import { Box, Grid, Typography, useTheme } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import OrdersInProgress from "./OrdersInProgress";
import { useGetOrdersStatusStatistics } from "./Hoock";
import DashboardChart from "./DashboardChart/DashboardChart";
import { actionsAccess } from "../../General/Components/ActionControlesUiAccess";
import UserNotifactionMessage from "./DashboardChart/UserNotifactionMessage";
import useDeviceType from "../global/Hooks/useDeviceType";
import LeaveReportToday from "./DashboardChart/LeaveReportToday/components/LeaveReportToday";
import useUSerSetting from "../../utils/useUSerSetting";
import ControllerDashChart from "./ControllerDashChart/ControllerDashChart";
import FunctionReports from "./../PersonFroms/FunctionDesignersReport/Components/FunctionReports/FunctionReports";
import DyModalControl from "../../General/Components/DyModalControl/DyModalControl";
import PrimaryButton from "../../General/Components/PrimaryButton/PrimaryButton";
import AssessmentIcon from '@mui/icons-material/Assessment';
import ReportIcon from "../../scenes/global/Icon/ReportsIcon";

const DashBoardCard = ({ fontIcon, title, detail }) => {
  const theme = useTheme().palette.mode;


  const deviceType = useDeviceType();
  return (
    <Box
      sx={{
        background: theme === "dark" ? "#262D39" : "#FFF",
        boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.14)",
        borderRadius: "1rem",
        padding: deviceType === "mobile" ? "0.5rem" : "1rem",
        "&:hover": {
          borderBottom: "2px solid #1E6AFD",
          background:
            "linear-gradient(264deg, rgba(255, 255, 255, 0.20) 28.91%, #B1D5FD 88.29%, rgba(30, 106, 253, 0.50) 122.7%)",
        },
      }}
    >
      {/* Header */}
      <Box display={"flex"} alignItems={"center"} marginBottom={"1.5rem"}>
        <div
          style={{
            width: deviceType === "mobile" ? "32px" : "48px",
            height: deviceType === "mobile" ? "32px" : "48px",
            borderRadius: "50%",
            border: "1px solid #1E6AFD",
            background: "#E6F1FF",
            position: "relative",
          }}
        >
          <i
            className={fontIcon}
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%,-50%)",
              fontSize: { md: "1.8rem", xs: "1rem" },
            }}
          ></i>
        </div>
        <Typography
          color={"#1E6AFD"}
          fontSize={{ md: "1.5rem", xs: "13px" }}
          marginLeft={"1rem"}
        >
          {title}{" "}
        </Typography>
      </Box>
      {/* detail */}
      <Box display={"flex"} alignItems={"center"}>
        {" "}
        {detail}
      </Box>

    </Box>
  );
};
function OverView() {
  const OrdersStatusStatistics = actionsAccess(
    "Dashboard",
    "GetOrdersStatusStatistics"
  );
  const OrdersInAllStepsCount = actionsAccess(
    "Dashboard",
    "GetAllOrdersInAllStepsCount"
  );
  const personLeaveTodayAccess = actionsAccess(
    "Dashboard",
    "GetPersonelLeaveReport"
  );
  const DashboardBoxesVisibility = actionsAccess(
    "Dashboard",
    "DashboardBoxesVisibility"
  );
  const { data } = useGetOrdersStatusStatistics(OrdersStatusStatistics);

    const functionReportAccess = actionsAccess(
    "GetDesignerPerformance"
  );


  



  const deviceType = useDeviceType();
  const [showReports, setShowReports] = useState(false);
  const [functionDesignersReportModule, setFunctionDesignersReportModule] = useState(false)
  return (
    <Box sx={{ padding: { md: "2rem", xs: "0.5rem" } }}>
      <Grid container spacing={1}>
        {OrdersStatusStatistics && (
          <>
            <Grid item xs={6} lg={3}>
              <DashBoardCard
                fontIcon={"icon-Users"}
                title={"تعداد کل مشتریان"}
                detail={
                  <Box display={"flex"} alignItems={"center"}>
                    <span className={'font-num'} style={{ color: "#4CAF50", fontSize: "18px" }}>
                      {data?.customers}
                    </span>
                    <span style={{ marginRight: "0.5rem" }}>مشتری</span>
                  </Box>
                }
              />
            </Grid>

            <Grid item xs={6} lg={3}>
              <DashBoardCard
                fontIcon={"icon-Group1"}
                title={"سفارشات تکمیل شده"}
                detail={
                  <Box display={"flex"} alignItems={"center"}>
                    <span
                      className={'font-num'}
                      style={{ color: "#4CAF50", fontSize: "18px" }}>
                      {data?.completedOrders}
                    </span>
                    <span style={{ marginRight: "0.5rem" }}>سفارش</span>
                  </Box>
                }
              />
            </Grid>
            <Grid item xs={6} lg={3}>
              <DashBoardCard
                fontIcon={"icon-Pen-Tool"}
                title={" سفارشات قفل شده"}
                detail={
                  <Box display={"flex"} alignItems={"center"}>
                    <span
                      className={'font-num'}
                      style={{ color: "#4CAF50", fontSize: "18px" }}>
                      {data?.lockedOrders}
                    </span>
                    <span style={{ marginRight: "0.5rem" }}> سفارش</span>
                  </Box>
                }
              />
            </Grid>
            <Grid item xs={6} lg={3}>
              <DashBoardCard
                fontIcon={"icon-setting"}
                title={" سفارشات در حال اجرا"}
                detail={
                  <Box display={"flex"} alignItems={"center"}>
                    <span
                      className={'font-num'}
                      style={{ color: "#4CAF50", fontSize: "18px" }}>
                      {data?.inProgressOrders}
                    </span>
                    <span style={{ marginRight: "0.5rem" }}> سفارش </span>
                  </Box>
                }
              />
            </Grid>
          </>
        )}

        <Grid container spacing={{ md: 1, xs: 0.5 }} margin={"1rem 0"}>
          <Grid item xs={12} lg={9}>
            <DashboardChart />
          </Grid>


          <Grid item xs={12} lg={3}>
            {deviceType != "mobile" && <UserNotifactionMessage />}
            {personLeaveTodayAccess && (
              deviceType != "mobile" && <LeaveReportToday deviceType={deviceType} />
            )}
            {OrdersInAllStepsCount && deviceType != "mobile" && <OrdersInProgress />}

            {DashboardBoxesVisibility && <ControllerDashChart />}
          </Grid>


        </Grid>
      </Grid>

   {
        DashboardBoxesVisibility  &&  <Box sx={{borderRadius:3,boxShadow:4}}  >
          <FunctionReports
            changeModuleMode={setFunctionDesignersReportModule}
          />
          </Box>
   }



  


    </Box>
  );
}

export default OverView;
